import type { BrandTwoLetterCode } from "brandRegionConfig";
import { getBrandByCode } from "resources/BrandMap";
import DomainMap from "resources/DomainMap";
import SubDomainMap from "resources/SubDomainMap";
import { getRuntimeEnvironmentVariable } from "./getRuntimeEnvironmentVariable";

export function getBrandTwoLetterCodeFromHost(
  host: string
): BrandTwoLetterCode | undefined {
  if (
    process.env.NODE_ENV === "development" &&
    host.split(":")[0] === "localhost" &&
    typeof window === "undefined"
  ) {
    const shortName = getRuntimeEnvironmentVariable(
      "NEXT_PUBLIC_DEFAULT_DEV_BRAND_CODE"
    );
    return shortName
      ? getBrandByCode(shortName)?.brandTwoLetterCode
      : undefined;
  }

  if (host.includes(".")) {
    const [subdomain, domainWithPossiblePort] = host.split(".");
    const domain = domainWithPossiblePort?.split(":")[0];
    const domainBrand = domain ? DomainMap.get(domain) : undefined;
    if (domainBrand) {
      return domainBrand;
    }
    return subdomain ? SubDomainMap.get(subdomain) : undefined;
  }

  const domain = host.split(":")[0];
  return domain ? DomainMap.get(domain) : undefined;
}
